export default __webpack_public_path__ + "static/media/Commander's Armguards of the Eastern Sun.57eaf923.jpg";